import styles from './index.module.css';

const Loading = () => {
  return (
    <div className={styles.container}>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export default Loading;
